<template>
  <div v-if="displayLabel" :class="classNames" :data-label="displayLabel">
    <span>{{ displayLabel }}</span>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LocationLabel',
  props: ['label', 'location', 'map', 'highlight', 'hover'],
  computed: {
    ...mapState(['highlightedLocation']),
    ...mapGetters(['isLocationHighlighted']),
    highlighted() {
      return (
        this.location &&
        (this.hover || this.isLocationHighlighted(this.location))
      )
    },
    deemphasized() {
      return this.map && this.highlightedLocation && !this.highlighted
    },
    displayLabel() {
      if (this.location) {
        return this.location.label || this.label
      }
      return this.label
    },
    classNames() {
      return {
        'is-on-map': this.map,
        'is-highlighted': this.highlighted,
        'is-deemphasized': this.deemphasized
      }
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
  width: 1.75em;
  height: 1.75em;
  /* width: 26px;
  height: 26px; */
  border-radius: 50%;
  border: 1px solid var(--color-highlight);
  box-shadow: 0 0 0 0.5px var(--color-highlight) inset;
  line-height: 1;
  text-align: center;
  color: var(--color-highlight);
  background-color: var(--color-background);
  transition: 250ms color, 250ms background-color;
  white-space: nowrap;
  overflow: hidden;
  @mixin type-small;
  font-weight: 600;
}
div.is-on-map {
  color: var(--color-background);
  background-color: var(--color-highlight);
  cursor: pointer;
  box-shadow: 0 0 0 2px white, 0 0 0 0.5px var(--color-highlight) inset;
}
@media screen {
  div.is-highlighted {
    color: var(--color-background);
    background-color: var(--color-highlight);
  }
  div.is-on-map.is-highlighted {
    animation: map-marker-blink 0.6s ease-in-out infinite alternate;
  }
  div.is-on-map.is-deemphasized {
    color: var(--color-highlight);
    background-color: var(--color-background);
  }
}
span {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%); /* scale(0.95, 0.95) */
  line-height: 1;
  div[data-label^='1'] & {
    left: 48%;
  }
  div[data-label='1'] & {
    left: 47%;
  }
  div[data-label='10'] & {
    left: 51%;
  }
}
@keyframes map-marker-blink {
  0%,
  45% {
    color: var(--color-highlight);
    background-color: var(--color-background);
  }
  55%,
  100% {
    color: var(--color-background);
    background-color: var(--color-highlight);
  }
}
</style>
